import React, { memo } from 'react'
import { Col, Row } from 'react-grid-system'
import { Button, Modal } from '../..'

import * as styles from './removeFromKitModal.module.scss'

const RemoveFromKitModal = ({
   itemForm,
   isModalOpen,
   handleRemoveFromKit,
   handleClose,
}: RemoveFromKitModalProps) => (
   <Modal
      title="Remove Item from Kit"
      isModalVisible={isModalOpen}
      closeModal={handleClose}
      zIndex="101"
   >
      <div className={styles.content}>
         <p>Are you sure you want to remove this item from the Kit?</p>
         <Row>
            <Col xs={12} sm={6}>
               <Button
                  type="button"
                  variant="danger"
                  minWidth="100%"
                  onClick={() =>
                     handleRemoveFromKit({
                        KitRemoveIDs: [itemForm.KitPrimeKey],
                     })
                  }
               >
                  Remove
               </Button>
            </Col>
            <Col xs={12} sm={6}>
               <Button
                  variant="tertiary"
                  onClick={handleClose}
                  type="button"
                  minWidth="100%"
               >
                  Cancel
               </Button>
            </Col>
         </Row>
      </div>
   </Modal>
)

export default memo(RemoveFromKitModal)
